<template>
    <div class="price flex">
        <div class="price__gold">            
            <div class="price__icon price__icon--gold"></div>
            {{ this.gold }}
        </div>
        <div class="price__wood">
            <div class="price__icon price__icon--wood"></div>
            {{ this.wood }}
        </div>        
        <div class="price__units" v-if="supply != null">
            <div class="price__icon price__icon--food"></div>
            {{ this.supply }}
        </div>
    </div>
</template>

<script>
    export default {
        name: "Price",
        props: ["gold", "wood", "supply"]
    }
</script>

<style lang="scss" scoped>
    .price {

        > div {
            @apply flex items-center font-bold;
            min-width: 6rem;
        }

        &__icon {
            width: 14px;
            height: 14px;
            margin-right: 5px;

            &--gold {
                background: url('../assets/images/gold_icon.png');
            }

            &--wood {
                background: url('../assets/images/wood_icon.png');
            }

            &--food {
                background: url('../assets/images/food_icon.png');
            }

        }
    }
</style>